import React, { Component } from 'react';

import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import config from 'react-global-configuration';
import { CoreLink, Menu } from '@uncinc/react-drupal-core';
import { Container, NavigationScroll } from '@uncinc/uncinc-react-kitchen-sink';

import { Hamburger, Logo } from '../../../components';
import { showNavMenu, hideNavMenu } from '../../../actions/UI';
import { TRANSPARENT_NAV_CONTENT_TYPE, NLDOET_DOMAIN, APPELTJES_DOMAIN, CONTENT_TYPE_LANDING_PAGE, CONTENT_TYPE_HOMEPAGE } from '../../../config/constants';
import NavigationSecondaryMenu from '../../Menus/NavigationSecondaryMenu';
import GenericNavigationMainMenu from '../../Menus/GenericNavigationMainMenu';
import GenericNavigationMainMobile from '../../Menus/GenericNavigationMainMenuMobile';

import './style.scss';

const NavigationCtaItem = ({ item }) => {
  const href = item?.link?.url ?? '';
  const title = item?.link?.title ?? 'Untitles';
  const classes = item?.link?.options?.attributes?.class ?? [];
  const itemClass = classNames('NavigationGeneric__itemWrapper', ...classes);

  return (
    <div className={itemClass}>
      <CoreLink href={href} className="NavigationGeneric__title">
        {title}
      </CoreLink>
    </div>
  );
};

class GenericHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuIsOpen: false,
      menuItemsToggled: [],
    };
  }

  onHamburgerClick = () => {
    this.state.menuIsOpen = !this.state.menuIsOpen;
    if (this.props.showNavMenu) {
      this.props.dispatch(hideNavMenu());
    } else {
      this.props.dispatch(showNavMenu());
    }
  };

  toggleNavigationItem = (entityId) => {
    const { menuItemsToggled } = this.state;

    this.setState((prevState) => ({
      menuItemsToggled: {
        ...menuItemsToggled,
        [entityId]: !prevState.menuItemsToggled[entityId],
      },
    }));
  };

  render() {
    const { menuItemsToggled } = this.state;

    const { path, entityType } = this.props;
    const domain = config.get('CURRENT_DOMAIN');

    const navigationGenericClassNames = classNames('NavigationGeneric', {
      'NavigationGeneric__transparentBackground': (TRANSPARENT_NAV_CONTENT_TYPE.includes(entityType) && domain !== APPELTJES_DOMAIN) || (domain === NLDOET_DOMAIN && path === '/zoeken') || (domain === APPELTJES_DOMAIN && entityType === CONTENT_TYPE_HOMEPAGE),
    });

    return (
      <NavigationScroll>
        <div className="NavigationGeneric__topBarBg" />
        <Container>
          <div className={navigationGenericClassNames} ref={(node) => this.menuNode = node}>
            <Logo />
            <div className="NavigationGeneric__right">
              <div className="NavigationGeneric__menus">
                <Menu id="main">
                  {(items) => {
                    return (
                      <>
                        <GenericNavigationMainMobile
                          items={items}
                        />
                        <GenericNavigationMainMenu
                          path={path}
                          items={items}
                          toggleNavigationItem={this.toggleNavigationItem}
                          menuItemsToggled={menuItemsToggled}
                        />
                      </>
                    );
                  }}
                </Menu>
                <NavigationSecondaryMenu />
              </div>
              <div className="NavigationGeneric__cta">
                <Menu id="navigation-cta-links">
                  {(items) => {
                    return items.toJS().map((item) => {
                      return <NavigationCtaItem item={item} />;
                    });
                  }}
                </Menu>
              </div>
              <div className="NavigationGeneric__mobile" onClick={this.onHamburgerClick}>
                <div className="NavigationGeneric__mobile__title">
                  {this.state.menuIsOpen ? 'Sluiten' : 'Menu'}
                </div>
                <Hamburger />
              </div>
            </div>
          </div>
        </Container>
      </NavigationScroll>
    );
  }
}

/**
 * @example
 * @param state
 * @param ownProps
 */
function mapStateToProps(state, ownProps) {

  return {
    path: state.getIn(['router', 'location', 'pathname']),
    showNavMenu: state.getIn(['uiInternal', 'showNavMenu']),
  };
}

export default withRouter(connect(mapStateToProps)(GenericHeader));
